module.exports = __webpack_public_path__ + "static/media/cup-jour5.cf56aecf.svg";